import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { Revenue } from '../types/revenue';
import { RevenueRepository } from '../repositories/revenue.repository';
import { BonusabfrageQuery } from '../types/bonusabfrage-query';
import { BonusabfrageQueryService } from './bonusabfrage-query.service';

@Injectable()
export class RevenueService extends ReadonlyRepositoryListService<
  Revenue,
  Result<Revenue[]>,
  BonusabfrageQuery | undefined
> {
  readonly #bonusabfrageQuery = inject(BonusabfrageQueryService);

  readonly #query = computed(() => this.#bonusabfrageQuery.bonusQuery()());

  override params = computed(() => {
    return this.#query();
  });

  constructor() {
    super(inject(RevenueRepository));
  }

  protected override getItems(result: Result<Revenue[]> | null | undefined): Revenue[] {
    return result as any;
  }
}
